import script from "./NoticeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeDialog.vue?vue&type=script&setup=true&lang=js"

import "./NoticeDialog.vue?vue&type=style&index=0&id=5b2a49de&lang=scss"

const __exports__ = script;

export default __exports__